import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { formatName } from './utils';

function GuestRsvpSummary({ selector, event, mealOptionsById, eventIndex }) { // eslint-disable-line
  return (
    <div className="guest-rsvp-summary">
      {selector('guests') && selector('guests').map((guest) => {
        const eventInvitationIndex = _.findIndex(guest.event_invitations, { event_id: event.id });
        return (
          <div key={guest.id} className="rsvp-info">
            <h4 className="guest-name">
              <span>{guest.name_unknown ? 'Guest Name Unknown' : formatName(guest.name.firstName, guest.name.familyName)}</span>
            </h4>
            <p className="guest-rsvp-response">
              {guest.event_invitations[eventInvitationIndex].rsvp_type === 'ATTENDING' ? (
                <span className="attending"><i className="zolaicon zolaicon-checkmark" /> Attending</span>
              ) : (
                <span className="declined"><i className="zolaicon zolaicon-close" /> Declined</span>
              )}
            </p>
            {guest.event_invitations[eventInvitationIndex].rsvp_type === 'ATTENDING' && mealOptionsById[guest.event_invitations[eventInvitationIndex].meal_option_id] && (
              <p className="guest-meal-option">
                Meal Choice: <span className="meal-choice">{mealOptionsById[guest.event_invitations[eventInvitationIndex].meal_option_id].name}</span>
              </p>
            )}
          </div>
        );
      })}
      {event.rsvp_questions.length > 0 && (
        <div className="rsvp-question-answers">
          {event.rsvp_questions.map(rsvpQuestion => (
            <div key={rsvpQuestion.id} className="rsvp-question-answer">
              <h4>{rsvpQuestion.question}</h4>
              <p>{selector(`rsvp_answers[${rsvpQuestion.id}].answer`)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

GuestRsvpSummary.propTypes = {
  selector: PropTypes.func.isRequired,
  event: PropTypes.shape({
    rsvp_questions: PropTypes.array,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  mealOptionsById: PropTypes.shape({}),
  eventIndex: PropTypes.number
};

export default GuestRsvpSummary;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/GuestRsvpSummary.jsx